export interface OverlayPanelPosition {
  top: number;
  left: number;
  width: number;
  constrainedDimensions?: ConstrainedDimensions;
}

export type ConstrainedDimensions = {
  width?: number;
  height?: number;
};

export const OverlayScrollDetectionType = {
  Parent: 0,
  All: 1,
} as const;
export type OverlayScrollDetectionType = (typeof OverlayScrollDetectionType)[keyof typeof OverlayScrollDetectionType];
